import React from 'react';
import styled from 'styled-components';
import noResultsImg from '../../assets/imgs/noResults.png';

const EmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 40px 20px;
`;

const EmptyMsg = styled.h2`
  color: #6b7280;
  padding: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
  `;

const NoResults = ({ message, searchText }) => (
  <EmptyContainer>
    <img src={noResultsImg} alt='noResults' />
    <EmptyMsg>
      {message}
      {searchText === '' ? (
        ''
      ) : (
        <span>
          {' '}
          com a palavra {' '}
          <strong style={{ fontWeight: '600', color: '#1a1a2e' }}>
            &quot;{searchText}&quot;
          </strong>
        </span>
      )}
      .
    </EmptyMsg>
  </EmptyContainer>
);

export default NoResults;
